import { render, staticRenderFns } from "./CompanyUserSetup.vue?vue&type=template&id=217c7b13&"
import script from "./CompanyUserSetup.vue?vue&type=script&lang=js&"
export * from "./CompanyUserSetup.vue?vue&type=script&lang=js&"
import style0 from "./CompanyUserSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports